(($) => {

	function lockPage() {
		document.body.classList.add('is-page-locked');
	}

	lockPage();

	let isLocked = true;
	let isPaused = false;
	let phase = 0; // 0 = show video (locked) -> first scroll hides, still locked; 1 = next scroll unlocks page

	let videoBlock;
	let videoBlocks = document.getElementsByClassName('wp-block-roobs-video');

	if (videoBlocks && videoBlocks.length)
		videoBlock = videoBlocks[0];

	function toggleFullscreen(video) {
		if (video.webkitEnterFullScreen) {
			video.webkitEnterFullScreen();
		} else if (video.requestFullscreen) {
			video.requestFullscreen();
		} else if (video.mozRequestFullScreen) {
			video.mozRequestFullScreen();
		} else if (video.webkitRequestFullscreen) {
			video.webkitRequestFullscreen();
		}
	}

	const prevent = e => {
		e.preventDefault();
		e.stopPropagation();
	};

	const onWheel = (e) => {
		if (e) prevent(e);
		if (!videoBlock) return;

		if (isLocked) {
			videoBlock.classList.add('is-hidden'); // hide video
			isLocked = false;

			setTimeout(() => unlock(), 200);
		} else {
			//unlock();
			// setTimeout(() => unlock(), 200);
		}
	};

	const onTouchMove = (e) => {
		onWheel(e);
	};

	const onKey = (e) => {
		const keys = ['Space', 'PageDown', 'PageUp', 'ArrowDown', 'ArrowUp', 'Home', 'End'];
		if (!keys.includes(e.code)) return;

		onWheel(e)
	};

	function unlock() {
		document.body.classList.remove('is-page-locked');
		cleanup();
	}

	function cleanup() {
		window.removeEventListener('wheel', onWheel, {passive: false});
		window.removeEventListener('touchmove', onTouchMove, {passive: false});
		window.removeEventListener('keydown', onKey, true);

		videoBlock.addEventListener('transitionend', () => videoBlock.remove(), {once: true});
	}

	window.addEventListener('wheel', onWheel, {passive: false});
	window.addEventListener('touchmove', onTouchMove, {passive: false});
	window.addEventListener('keydown', onKey, true);

	// $(document).on('webkitExitFullScreen', onWheel);

	if (videoBlock) {
		const videoContainer = videoBlock;
		const video = videoContainer.children[0];
		const controls = videoContainer.children[1];
		const btn = controls.firstChild;

		if (localStorage.getItem('consent.age') !== '1') {
			video.pause();
			isPaused = true;
		}

		btn.addEventListener('click', async () => {
			try {
				// toggleFullscreen(video);
				video.muted = false;
				video.volume = 1;
				await video.play();

				btn.style.display = 'none';
			} catch (e) {
				console.warn('Playback blocked:', e);
			}
		});

		// // Fullscreen
		// $(video).bind('webkitfullscreenchange mozfullscreenchange fullscreenchange', function(e) {
		// 	const isFullscreen = document.fullScreen || document.mozFullScreen || document.webkitIsFullScreen;
		// 	onWheel();
		// });

		// document.addEventListener("fullscreenchange", function () {
		// 	if (document.fullscreen) {
		// 		console.log('Entering Full Screen Toggle');
		// 	} else {
		// 		onWheel();
		// 	}
		// });

		// If consent was blocking the video
		$(document).on('consentCheck', function (event) {
			console.log(event);
			if (isPaused) {
				isPaused = false;
				video.play();
			}
		})
	}

})(jQuery);
